// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"2f4ab976","794":"7596abb8"}[chunkId] + ".chunk.js";
};